import { DocumentType } from "@ctypes";
import { DOCUMENTS } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useDocuments = (type: DocumentType | undefined) => {
  const { data: queryData, ...rest } = useQuery(DOCUMENTS, {
    variables: { input: { types: type ? [type] : [] } },
    skip: type == null,
  });

  const documents = queryData?.documents;

  return { documents, ...rest };
};
